import React, { useState, useEffect } from 'react';
import { listenToAdminLogs } from '../services/firebase';

const fmt = (ts) => (ts?.toDate ? ts.toDate().toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => listenToAdminLogs(setLogs), []);

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Activity Log</div>
        <div style={{ fontSize: 13, color: 'var(--text2)' }}>Admin mutations · last {logs.length} entries</div>
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr><th>TIME</th><th>ACTION</th><th>TARGET</th><th>ADMIN</th><th>DETAILS</th></tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text2)', padding: 32 }}>No activity yet</td></tr>
            ) : logs.map((log) => (
              <tr key={log.id}>
                <td style={{ fontFamily: 'JetBrains Mono', fontSize: 11, color: 'var(--text2)', whiteSpace: 'nowrap' }}>{fmt(log.createdAt)}</td>
                <td><span className="badge badge-blue">{log.action}</span></td>
                <td style={{ fontFamily: 'JetBrains Mono', fontSize: 11 }}>{log.target || '—'}</td>
                <td style={{ fontSize: 12 }}>{log.adminEmail || log.adminId?.slice(0, 8) || '—'}</td>
                <td style={{ fontSize: 11, color: 'var(--text2)', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {log.details ? JSON.stringify(log.details) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
